/**
 * Event name enum (ensures type safety)
 */
export var ShellEvent;
(function (ShellEvent) {
    // User-related
    ShellEvent["USER_LOGOUT"] = "user:logout";
    ShellEvent["USER_LOGIN"] = "user:login";
    ShellEvent["USER_PROFILE_UPDATED"] = "user:profile:updated";
    // Navigation-related
    ShellEvent["NAVIGATION_CHANGED"] = "navigation:changed";
    // Settings-related
    ShellEvent["SETTINGS_UPDATED"] = "settings:updated";
    // Notification-related
    ShellEvent["NOTIFICATION_SHOW"] = "notification:show";
    ShellEvent["NOTIFICATION_HIDE"] = "notification:hide";
})(ShellEvent || (ShellEvent = {}));
